import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import { MdsTabBar } from "@/design-system/components/tab-bar";
import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import { MdsPanelContainer } from "@/design-system/components/panel";
import {
  MDSText,
  MDSTextVariant,
  MDSPanelHeader,
  MDSPanelHeaderSlotName,
  MDSVerticalDivider,
} from "@/mds";
import { FeatureGateBanner } from "@/components/banners/feature-gate-banner/feature-gate-banner";

interface SettingsGeneralPageProps {
  children: React.ReactNode;
}

export const SettingsLayout: FC<SettingsGeneralPageProps> = observer(({ children }) => {
  const { pageStore } = useAppStore();
  const page = pageStore.settingsPage;
  page.useSettingsPageParams();

  return (
    <>
      <MDSPanelHeader>
        <MDSText
          slot={MDSPanelHeaderSlotName.Heading}
          variant={MDSTextVariant.HeaderXl}
          numberOfLines={1}
        >
          Settings
        </MDSText>
      </MDSPanelHeader>
      <FeatureGateBanner />
      <Wrapper>
        <Container>
          <MdsTabBar sections={page.tabBarSections} selectedItemId={page.selectedTabId} />
          <StyledVerticalDivider />
          <ContentContainer>{children}</ContentContainer>
        </Container>
      </Wrapper>
    </>
  );
});

const Wrapper = styled.div({
  height: "100%",
  maxHeight: "100%",
  overflowY: "scroll",
  scrollbarWidth: "none",
});

const Container = styled(MdsPanelContainer)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  padding: `${theme.spacing[4]} ${theme.spacing[3]} 0 0`,
  flex: "1 0 0",

  "@container mds-panel (max-width: 750px)": {
    flexDirection: "column",
    height: "auto",
    gap: theme.spacing[2],
    paddingRight: 0,
  },
}));

const ContentContainer = styled.div({
  height: "100%",
  width: "100%",
  scrollbarWidth: "none",
});

const StyledVerticalDivider = styled(MDSVerticalDivider)({
  marginLeft: 0,
  "@container mds-panel (max-width: 750px)": {
    display: "none",
  },
});
